// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checklist-status-row {
  width: 100px;
}
.checklist-status-row .checklist-status-progress-bar-container {
  width: 100%;
  height: 5px;
  border-radius: 20px;
  position: relative;
}
.checklist-status-row .checklist-status-progress-bar-container .checklist-status-item {
  position: absolute !important;
  top: 0;
  left: 0;
  height: 5px;
  border-radius: 20px;
  transition: all 0.2s;
}
.checklist-status-row .checklist-status-progress-bar-container .checklist-status-item.completed {
  background: linear-gradient(180deg, #29cc6a 0%, #18c45d 100%);
  z-index: 3;
}
.checklist-status-row .checklist-status-progress-bar-container .checklist-status-item.in-progress {
  background: linear-gradient(180deg, #ef9150 2.11%, #ff8e1c 38.58%);
  z-index: 2;
}
.checklist-status-row .checklist-status-progress-bar-container .checklist-status-item.not-started {
  background: linear-gradient(180deg, #e5eff5 0%, #c7c8c9 100%);
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checklist/fi-checklist2-report/components/shared/checklist-status-row/checklist-status-row.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AAAI;EACI,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAER;AADQ;EACI,6BAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;AAGZ;AAFY;EACI,6DAAA;EACA,UAAA;AAIhB;AAFY;EACI,kEAAA;EACA,UAAA;AAIhB;AAFY;EACI,6DAAA;EACA,UAAA;AAIhB","sourcesContent":[".checklist-status-row {\r\n    width: 100px;\r\n    .checklist-status-progress-bar-container {\r\n        width: 100%;\r\n        height: 5px;\r\n        border-radius: 20px;\r\n        position: relative;\r\n        .checklist-status-item {\r\n            position: absolute !important;\r\n            top: 0;\r\n            left: 0;\r\n            height: 5px;\r\n            border-radius: 20px;\r\n            transition: all 0.2s;\r\n            &.completed {\r\n                background: linear-gradient(180deg, #29cc6a 0%, #18c45d 100%);\r\n                z-index: 3;\r\n            }\r\n            &.in-progress {\r\n                background: linear-gradient(180deg, #ef9150 2.11%, #ff8e1c 38.58%);\r\n                z-index: 2;\r\n            }\r\n            &.not-started {\r\n                background: linear-gradient(180deg, #e5eff5 0%, #c7c8c9 100%);\r\n                z-index: 1;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
